// Add/Edit
export const INE_REQUEST_START_LOADING = "INE_REQUEST_START_LOADING";
export const INE_REQUEST_END_LOADING = "INE_REQUEST_END_LOADING";
export const INE_REQUEST_LOADED = "INE_REQUEST_LOADED";
// Search
export const INE_REQUEST_SEARCH_START_LOADING = "INE_REQUEST_SEARCH_START_LOADING";
export const INE_REQUEST_SEARCH_END_LOADING = "INE_REQUEST_SEARCH_END_LOADING";
export const INE_REQUEST_SEARCH_LOADED = "INE_REQUEST_SEARCH_LOADED";
export const SET_INE_REQUEST_FILTER = "SET_INE_REQUEST_FILTER";
